import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BackendEndpoints } from '../models/backend-endpoints';
import { API_ENDPOINTS } from '../models/api-endpoints';


@Injectable({ providedIn: 'root' })
export class ConfigService {
    private config: BackendEndpoints = API_ENDPOINTS['local-scania']; // default to local-scania, will be overridden by setBrand()

    private resolveEndpointBrand(brand: string): string {
        if (environment.name.startsWith('us-')) {
            return 'international';
        }

        return (brand || environment.defaultBrand).toLowerCase();
    }

    get apiUrl(): string {
        return this.config?.apiUrl ?? "";
    }

    get hubUrl(): string {
        return this.config?.hubUrl ?? "";
    }

    get newUiUrl(): string {
        return this.config?.newUiUrl ?? "";
    }

    get odxApiUrl(): string {
        return this.config?.odxApiUrl ?? "";
    }

    get mainAppUrl(): string {
        return this.config?.mainAppUrl ?? "";
    }

    setBrand(brand: string) {
        const apiEndPointSelector = environment.name + '-' + this.resolveEndpointBrand(brand);
        const fallbackSelector = `${environment.name}-${this.resolveEndpointBrand(environment.defaultBrand)}`;

        this.config = API_ENDPOINTS[apiEndPointSelector] || API_ENDPOINTS[fallbackSelector];

        if (!this.config) {
            throw new Error(`Missing API endpoint configuration for selectors: ${apiEndPointSelector}, ${fallbackSelector}`);
        }
    }
}
